import { CheckCircle2 } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { SubscribeButton } from "./SubscribeButton";
import { ReferralInput } from "./ReferralInput";

const CARDS = [
  "Sei un libero professionista e vuoi attirare clienti senza spendere una fortuna",
  "Gestisci una piccola attività e vuoi social sempre curati, senza spendere cifre enormi",
  "Sei stanco dei preventivi gonfiati e dei contratti infiniti delle agenzie",
  "Vuoi imparare a creare contenuti efficaci anche in autonomia",
];

export const ForWho = () => (
  <section id="fa-per-te" data-testid="for-who-section" className="mx-auto max-w-6xl px-5 py-12">
    <Chapter number="03" label="Fa per te se..." />
    <Reveal>
      <h2 className="text-center font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
        Fa per te se...
      </h2>
      <p className="mx-auto mt-2 max-w-xl text-center text-base text-slate-600">
        Progettato esattamente per la realtà delle piccole attività italiane.
      </p>
    </Reveal>
    <div className="mt-8 grid gap-4 sm:grid-cols-2">
      {CARDS.map((card, i) => (
        <Reveal key={card} delay={i * 0.08}>
          <div
            data-testid={`for-who-card-${i}`}
            className="group flex h-full items-start gap-4 rounded-3xl border border-purple-100 bg-white p-6 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-purple-300 hover:shadow-xl hover:shadow-purple-600/10"
          >
            <CheckCircle2 className="mt-0.5 h-6 w-6 shrink-0 text-purple-600 transition-transform duration-300 group-hover:scale-110" />
            <p className="text-base font-medium leading-relaxed text-slate-800">{card}</p>
          </div>
        </Reveal>
      ))}
    </div>
    <Reveal delay={0.2} className="mt-8 flex flex-col items-center justify-center">
      <SubscribeButton testid="forwho-subscribe-cta-button" />
      <ReferralInput suffix="forwho" />
    </Reveal>
  </section>
);
